import { Buildings, Users, Wallet, type Icon } from "@phosphor-icons/react";
import { useCreateInvestmentStore } from "@/stores/useCreateInvestmentStore";
import { useShellCreateStore } from "@/stores/useShellCreateStore";

export type ShellCreateKind = "investment" | "beneficiary" | "investor";

export const SHELL_CREATE_ACTIONS: {
  label: string;
  hint?: string;
  kind: ShellCreateKind;
  icon: Icon;
}[] = [
  {
    label: "shell.new_investment",
    hint: "shell.new_investment_hint",
    kind: "investment",
    icon: Wallet,
  },
  { label: "shell.new_promoter", kind: "beneficiary", icon: Buildings },
  { label: "shell.new_investor", kind: "investor", icon: Users },
];

export function startShellCreate(kind: ShellCreateKind) {
  if (kind === "investment") useCreateInvestmentStore.getState().open();
  else useShellCreateStore.getState().open(kind);
}
